/**
 * Subtitle of a list with its record count. Above the backend's estimate
 * threshold the person lists are not counted exactly (DB-928): `totalRecords`
 * is then the threshold, `totalRecordsExact` false, and the subtitle says
 * "more than" that number.
 *
 * @param formatMessage react-intl formatMessage
 * @param totalRecords total of the search, or its lower bound
 * @param totalRecordsExact false when the total is a lower bound; a response
 *   without the flag is exact
 * @returns the subtitle
 */
export var formatRecordsFound = function (formatMessage, totalRecords, totalRecordsExact) {
    return formatMessage({
        id: totalRecordsExact === false
            ? "ui-br-agency.table.subtitle.records-found-more-than"
            : "ui-br-agency.table.subtitle.records-found",
    }, { count: totalRecords });
};
